import { createRouter, createWebHistory } from 'vue-router';
import { useApiStore } from '@/stores/api';
import ImageView from '../views/ImageView.vue';
import LoginView from '../views/LoginView.vue';
import ReactiveImageTestView from '../views/ReactiveImageTestView.vue';
import SentryTestView from '../views/SentryTestView.vue';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: ImageView,
    },
    {
      path: '/login',
      name: 'login',
      component: LoginView,
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/AboutView.vue'),
    },
    {
      path: '/test/reactive_image',
      name: 'reactive-image-test',
      component: ReactiveImageTestView,
      meta: {
        allowAnonymous: true,
      },
    },
    {
      path: '/test/sentry',
      name: 'sentry-test',
      component: SentryTestView,
      meta: {
        allowAnonymous: true,
      },
    },
  ],
});

router.beforeEach((to, from) => {
  const apiConfig = useApiStore();
  const hasApiKey = !!apiConfig.apiKey;
  console.log(
    `Checking login for route ${String(to.name)} (${
      to.fullPath
    }), coming from route ${String(from.name)} (${
      from.fullPath
    }), authenticated: ${hasApiKey}`,
  );
  if (
    // Avoid an infinite redirect and check that we have a token
    to.name === 'login' ||
    to.meta.allowAnonymous === true
  ) {
    return true;
  }
  if (!hasApiKey) {
    // redirect the user to the login page
    return {
      name: 'login',
      query: to.query,
    };
  }
  return true;
});

export default router;
